import "./button.scss";

function Button({ children, size = "full", color = "dark", onClick, disabled, type = "button" }) {
  return (
    <button
      className={`Button Button-${size} Button-${color} ${disabled ? "Button-disabled" : ""}`}
      onClick={onClick}
      disabled={disabled}
      type={type}
    >
      {children}
    </button>
  );
}
export default Button;